import React, { useEffect, useState } from 'react'
import TopBar from '../Layouts/TopBar'
import Sidebar from '../Layouts/Sidebar'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import axios from 'axios';
import instance from '../Config/AxiosConfig';
import Cookies from 'js-cookie';
import { useDelete } from '../Context/ApiContext';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function About() {
  const [interest, setInterest] = useState([]);
  const { id } = useParams();
  const [myProfil, setMyProfil] = useState("");
  useEffect(() => {
    instance.get(`/users/get/${id}`)
      .then(response => {
        setMyProfil(response.data);
        ;
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des données:', error);
      });
  }, []);
  const { showConfirmDialog, deleteResponse } = useDelete()
  const api = "interests/delete"
  useEffect(() => {

    const token = Cookies.get('token');

    instance.get("/interests/interestsUser", token)
      .then(response => {
            setInterest(response.data);
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des interest:', error);
      });

  }, [deleteResponse]);


  const [showProjectModal, setShowProjectModal] = useState(false);


  const handleProjectModalOpen = () => {
    setShowProjectModal(true);
  };

  const handleProjectModalClose = () => {
    setShowProjectModal(false);
  };
   const [allInterest, setAllInterest] = useState([]);
  const [search, setSearch] = useState('')

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [checkedItems, setCheckedItems] = useState({});
  //checked interest
  const handleCheckboxChange = (event, interest) => {
    setCheckedItems({
      ...checkedItems,
      [interest.id]: event.target.checked
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const selectedInterests = Object.keys(checkedItems).filter(id => checkedItems[id]);

    try {
      setIsSubmitting(true);
      const requests = selectedInterests.map(id =>
        instance.get(`/interests/add/${id}`)
      );
      const responses = await Promise.all(requests);

      console.log('Responses:', responses);
      const allSuccessful = responses.every(response => response.status === 200);

      if (allSuccessful) {

        toast.success('Interest added successfully!', {
          position: "top-center",

          hideProgressBar: false,

        });


        const Interestsfiltred = allInterest.filter(interest => !selectedInterests.includes(interest.id.toString()));
        setAllInterest(Interestsfiltred);


        await fetchUserInterests();

        setShowProjectModal(false);
      }

    } catch (error) {
      console.error('Error adding interests:', error);

    } finally {
      setIsSubmitting(false);
    }
  };

  const fetchSearchInterests = async () => {


    const token = Cookies.get('token');
    let dat = {
      keyword: search
    }
    try {
      const response = await instance.get(`/interests/search/web`, token);

      setAllInterest(response.data);

    }
    catch (error) {
      console.error('Erreur lors de la récupération des Communities:', error);
    };

  }

  const fetchUserInterests = async () => {

    const token = Cookies.get('token');

    instance.get("/interests/interestsUser", token)
      .then(response => {
        setInterest(response.data);
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des interest:', error);
      });

  }

  useEffect(() => {

    fetchSearchInterests(); // Appeler handleSearch avec un événement fake
  }, []);

  return (

    <>
      <TopBar />
      <main>
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-3">
              <Sidebar />
            </div>
            <div className="col-md-8 col-lg-9 vstack gap-4">


              <div className="card">
                {/* Card header START */}
                <div className="card-header border-0 pb-0">
                  <h5 className="card-title"> Profile Info</h5>
                </div>
                {/* Card header END */}
                {/* Card body START */}
                <div className="card-body">
                  <div className="rounded border px-3 py-2 mb-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <h5>Bio </h5>

                    </div>
                    <p> {myProfil.aboutDescription}  </p>

                  </div>
                  <div className="row g-4">
                    <div className="col-sm-6 ">
                      <h5>Interests</h5>

                    </div>
                    <div className="col-sm-6 position-relative" onClick={handleProjectModalOpen}>

                      <a className="btn btn-dashed rounded w-100" href="#!"> <i className="bi bi-plus-circle-dotted me-1" />Add Interest</a>


                    </div>

                    {
                      interest.length > 0 ?
                        interest.map((interest, i) => (
                          <div className="col-sm-6">
                            {/* Birthday START */}
                            <div className="d-flex align-items-center rounded border px-3 py-2">
                              {/* Date */}
                              <p className="mb-0">
                                <strong>  {interest.name}</strong>
                              </p>
                              <div className="dropdown ms-auto">
                                {/* Card share action menu */}
                                <a className="nav nav-link text-secondary mb-0" href="#" id="aboutAction2" data-bs-toggle="dropdown" aria-expanded="false">
                                  <i className="bi bi-three-dots" />
                                </a>
                                {/* Card share action dropdown menu */}
                                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="aboutAction2" style={{}}>

                                  <li onClick={() => showConfirmDialog(api, interest.id)} ><a className="dropdown-item" href="#"> <i className="bi bi-trash fa-fw pe-2" />Delete</a></li>
                                </ul>
                              </div>
                            </div>
                            {/* Birthday END */}
                          </div>

                        ))
                        :
                        <p> pas d'ineterst </p>
                    }


                  </div>
                </div>
                {/* Card body END */}
              </div>

              {/* Modal pour l'ajout d'interest' */}
              {showProjectModal &&
                <>


                  <Modal show={showProjectModal} onHide={handleProjectModalClose} style={{ marginTop: "50px" }}>
                    <Modal.Header closeButton>
                      <Modal.Title>Add new interest</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>


                      <div className="row mt-3 scroll-hidden" style={{
                        height: " 350px",
                        overflow: "scroll"
                      }}>
                        <form className="row g-3 ms-2" onSubmit={handleSubmit}>


                          {allInterest &&
                            allInterest.map((interest, i) => {
                              return (
                                <div className="form-check form-check-md my-3" key={i}>
                                  <input className="form-check-input"
                                    type="checkbox"
                                    id={`interest-${interest.id}`}
                                    checked={checkedItems[interest.id] || false}
                                    onChange={(e) => handleCheckboxChange(e, interest)} />
                                  <label className="form-check-label" htmlFor={`interest-${interest.id}`}>{interest.name}</label>
                                </div>

                              )
                            })

                          }

                        </form>
                      </div>
                    </Modal.Body>

                    <Modal.Footer>
                      <Button onClick={handleSubmit} disabled={isSubmitting} type="submit" className="btn btn-primary mb-0">{isSubmitting ? 'Saving...' : 'Save changes'}
                      </Button>

                    </Modal.Footer>


                  </Modal>

                </>}
            </div>
          </div>
        </div>
      </main >
    </>
  )
}

export default About